const e = {
  name: "ZoomOut",
  dimensions: { width: 20, height: 20 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 9C14 9.55229 13.5523 10 13 10H5C4.44771 10 4 9.55228 4 9C4 8.44771 4.44771 8 5 8L13 8C13.5523 8 14 8.44771 14 9Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 11.125 17.2635 13.078 16.0319 14.6177L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L14.6177 16.0319C13.078 17.2635 11.125 18 9 18C4.02944 18 0 13.9706 0 9ZM9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as ZoomOut
};
